import { getPlainText, getRichText
// @ts-expect-error module not typed
} from '../../../common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { getEvaluatedTextContent } from './getEvaluatedTextContent';
import { getHasReplies } from '../../../common-message-format/operators/emailMetadataGetters';
import { lruMemoize } from '../../../util/lruMemoize';
export const hasTextContent = lruMemoize(message => {
  // @ts-expect-error - message may not have all CommonMessage properties but getHasReplies will return undefined if it doesn't.
  const hasReplies = !!getHasReplies(message);
  const html = getRichText(message) || getPlainText(message);
  return hasReplies || Boolean(html && html.length && getEvaluatedTextContent(html));
});